/**
 * Brand accents a business may choose for its public page. Each pair has
 * been checked for WCAG AA contrast of white text on the accent and of the
 * accent as text on white, so any choice stays readable.
 */
export const ACCENTS = {
  blue: { name: 'Blue', color: '#1d4ed8', soft: '#dbeafe' },
  indigo: { name: 'Indigo', color: '#4338ca', soft: '#e0e7ff' },
  teal: { name: 'Teal', color: '#0f766e', soft: '#ccfbf1' },
  green: { name: 'Green', color: '#15803d', soft: '#dcfce7' },
  rose: { name: 'Rose', color: '#be123c', soft: '#ffe4e6' },
  amber: { name: 'Amber', color: '#b45309', soft: '#fef3c7' },
  slate: { name: 'Slate', color: '#334155', soft: '#e2e8f0' },
  plum: { name: 'Plum', color: '#7e22ce', soft: '#f3e8ff' },
} as const;

export type AccentName = keyof typeof ACCENTS;
export const ACCENT_NAMES = Object.keys(ACCENTS) as AccentName[];

export function isAccentName(value: unknown): value is AccentName {
  return typeof value === 'string' && value in ACCENTS;
}
